import { Space } from "antd";
import styled from "styled-components";

export const Container = styled(Space)`
  width: 100%;
  max-width: 480px;
  padding: 12px 0;
  align-items: flex-end;
  text-align: center;
  position: fixed;
  bottom: 0;
  background: linear-gradient(180deg, #6d1d7a, #94378c);

  .ant-space-item {
    flex: 0.25;
  }
`;

export const ItemWrapper = styled.div`
  text-align: center;
  cursor: pointer;

  #msg-active-icon {
    width: 26px;
    height: 26px;
  }
`;

export const Label = styled.div`
  font-size: 12px;
  font-weight: 500;
  font-style: normal;
  letter-spacing: normal;
  color: ${(props) => (props.status === "active" ? "#FFCFE9" : "#FFFFFF")};

  @media screen and (max-width: 352px) {
    font-size: 11px;
  }

  @media screen and (max-width: 325px) {
    font-size: 10px;
  }

  @media screen and (max-width: 298px) {
    font-size: 9px;
  }

  @media screen and (max-width: 272px) {
    font-size: 8px;
  }
`;
